__webpack_require__.p = "/sandbox-tensorflow-frontend/";